import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import Iframe from 'components/Iframe/Iframe';
import { getDiscoverIframeUrl } from '../../constants';
import Media from 'react-media';
import styles from 'theme';
import { Route, Routes } from 'react-router-dom';
import ResultView from './ResultView';
import {
  ROUTE_DISCOVER_QUESTIONNAIRE,
  ROUTE_DISCOVER_RESULT
} from '../../RouteList';
import Intro from './Intro';
import { useStores } from '../../store/useStores';

function Discover() {
  const {
    authStore: { user, isImpersonator }
  } = useStores();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentUser = isImpersonator || user;

  return (
    <Routes>
      <Route index element={<Intro />} />
      <Route
        path="questionnaire"
        element={
          <Media query={{ maxWidth: styles.mq.large }}>
            {matches =>
              currentUser.email && (
                <Iframe
                  src={getDiscoverIframeUrl(currentUser)}
                  height={matches ? 'calc(100vh - 145px)' : '100%'}
                />
              )
            }
          </Media>
        }
      />
      <Route path="result" element={<ResultView />} />
    </Routes>
  );
}

export default observer(Discover);
